import React from 'react';
import { StyledConfigurationContainer, StyledFlexEnd, StyledLeadContainer } from '../../../Components/Styled';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import SelectBoxWithLabel from '../../../Components/SelectBoxWithLable';
import { Box, Button, Stack, Typography } from '@mui/material';
import { functionSearchLabel, functionSearchName, applicationStatusmenu } from '../../../Configuration/ConfigurationMenu';
import { useState } from 'react';
import SearchModuleButton from '../../../Components/SearchModuleButton';
import CreateEditFunction from './CreateEditFunction';
import { createOrderRequestData } from '../../../Utility/apiHelper';
import { useSnackbar } from 'notistack';
import DataGridTable from '../../../Components/DataGrid';
import { useDispatch, useSelector } from 'react-redux';
import BiztantuLoader from '../../../Components/Loader';
import { useEffect } from 'react';
import { requestGetAllPermission } from '../../../Store/Function/action';
import { GridActionsCellItem } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import { handleValidateCodevalue } from '../../../Utility/constant';
import BiztantuSearch from '../../../Components/BiztantuSearch';
import { handleCreateEditConfiguration } from '../../../Store/Global/action';
import createicon from '../../../Assets/images/add.png';

const ConfigurationFunction = ({}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [formValues, setFormValues] = useState({});
    const [selectionData, setSelectionData] = useState({
        isCreate: false,
        isEdit: false, 
        isEditPermissionId: ""
    })
    const [datagriddata, setdatagriddata] = useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const dispatch = useDispatch();
    const isLoadingProgress = useSelector(state => state?.global.isLoading); 
    const [selectionModel, setSelectionModel] = React.useState([]);
    const permissionData = useSelector(state => state?.permission?.allPermissionTypes);
    useEffect(() => {
       
        if(!selectionData?.isCreate) {
            dispatch(requestGetAllPermission());
       }
     
    },[selectionData])

    useEffect(() => {
        setdatagriddata(permissionData);
    },[permissionData])
    const {enqueueSnackbar} = useSnackbar();

    const handleOnChange = (event) => {
        setFormValues({
            ...formValues,
            [event.target.name]: event.target.value
        })
    }

    const handleSearch = () => {

    }

    const handleResetSearch = () => {

    }

    const handleEditPermission = (id) => {
        setSelectionData({
            isCreate: false,
            isEdit: true,
            isEditPermissionId: id
        });

          dispatch(handleCreateEditConfiguration(true));
    }

    const handleCreatePermission = () => {
        setSelectionData({
            isCreate: true,
            isEdit: false
        })  ;
        
          dispatch(handleCreateEditConfiguration(true));
    }

    const handleCustomBackbutton = () => {
        setSelectionData({
            isCreate: false,
            isEdit: false
        });

        dispatch(handleCreateEditConfiguration(false));
    }

    const columns = [
        { 
          field: 'name', 
          headerName: handleValidateCodevalue(internationalise,'CONF_PERM_SEARCH_NAME'),
          flex: 1,
          editable: false ,
        },
        {
            field: 'description',
            headerName: handleValidateCodevalue(internationalise,'CONF_PERM_SEARCH_DESC'),
            flex: 1,
            editable: false,
        },
        // {
        //     field: 'actions',
        //     type: 'actions',
        //     headerName: 'Actions',
        //     width: 100,
        //     cellClassName: 'actions',
        //     getActions: ({ id }) => {
             
        //       return [
        //         <GridActionsCellItem
        //           icon={<EditIcon />}
        //           label="Edit"
        //           className="textPrimary"
        //           disabled = {true}
        //           onClick={() => handleEditPermission(id)}
        //           color="inherit"
        //         />
        //       ];
        //     },
        // },
      ];

    const handleSavePermission = async(permissiondata) => {
        const url = `${process.env.REACT_APP_ORDER_URL}permissions`;
         const reqBody = {
            "description": (permissiondata?.description || "").trim(),
            "name": (permissiondata?.permissionName||"").trim()
        }
            const responseData = await createOrderRequestData(reqBody, url);

            if(responseData?.status == 200) {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_CREATED_SUCCESSFULLY") , {variant: "success"});
            } else {
enqueueSnackbar(
  handleValidateCodevalue(
    internationalise,
    responseData?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
  ),
  { variant: "error" }
);
    }}

    return (

        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
        
            {!selectionData?.isCreate ? <Box sx={{marginBottom: 3, backgroundColor: "white",
                // '& .MuiTextField-root': { m: 1, width: '35ch', marginTop: 3 },

                }}>
                <StyledConfigurationContainer>
                    <Typography variant='h6' className=''>
                         {handleValidateCodevalue(internationalise,'CONF_PERM_SEARCH_TITLE')}
                </Typography>
                
                <Button startIcon={<img src={createicon} style={{height: "15px"}} />} className='biztantu-sec-btn'  onClick={handleCreatePermission}>{handleValidateCodevalue(internationalise,'CONF_CREATE_PERM')}</Button>
            
                </StyledConfigurationContainer>
                              
                <DataGridTable
                    dataGridData={datagriddata}
                    height={"calc(100vh - 221px)"}
                    isLoading={false}
                    columns={columns}
                    marginTop = "0px"
                    selectionModel={selectionModel}
                    setSelectionModel={(data) => setSelectionModel(data)}
                    rowModesModel={rowModesModel}
                    // handleUpdateProduct={handleUpdateProduct}
                />
            </Box> :
            <CreateEditFunction
                selectionData = {selectionData}
                handleSavePermission = {handleSavePermission}
                handleCustomBackbutton = {handleCustomBackbutton}
            />}
        </BiztantuLoader>
    )
}

export default ConfigurationFunction;